import styled, { css } from "styled-components";

import DefaultAppBar from "@material-ui/core/AppBar";
import DefaultToolbar from "@material-ui/core/Toolbar";

import DefaultLoader from "../Loader";

import {
  HEADER_HEIGHT,
  SIDEBAR_WIDTH,
  PAGE_TOP_CONTROLS_HEIGHT,
} from "constants/layout";

import { COLORS } from "constants/colorScheme";

export const Container = styled.div`
  height: 100%;
  width: 100%;

  display: flex;
  flex-direction: column;

  padding: 32px;

  ${({ withTopControls }: { withTopControls: boolean }) =>
    withTopControls &&
    css`
      margin-top: ${PAGE_TOP_CONTROLS_HEIGHT};
    `}
`;

export const Content = styled.div`
  position: relative;
  min-width: 100%;
  width: 0;
  flex: 1;
`;

export const TopControlsContainer = styled(DefaultAppBar)`
  && {
    position: fixed;
    top: ${HEADER_HEIGHT};
    left: ${SIDEBAR_WIDTH};

    width: 100%;
    height: ${PAGE_TOP_CONTROLS_HEIGHT};

    padding: 0;

    background-color: ${COLORS.WHITE};
  }
`;

export const TopControlsToolbar = styled(DefaultToolbar)`
  && {
    justify-content: flex-start;
    align-items: center;

    height: 100%;
    min-height: ${PAGE_TOP_CONTROLS_HEIGHT};

    padding: 0;
  }
`;

export const Loader = styled(DefaultLoader)`
  position: absolute;
  top: 0;
  right: 0;
`;
